import { Box, Text } from '@chakra-ui/react'
import { FC } from 'react'

type StaticContentProps = {
  title?: string
  body: string
}

export const StaticContent: FC<StaticContentProps> = ({ title, body }) => {
  return (
    <Box>
      <Text fontSize={28} fontWeight="medium" lineHeight="36px" mb={8}>
        {title}
      </Text>
      <Box
        sx={{
          '& h2': {
            fontSize: 24,
            fontWeight: 'bold',
            lineHeight: '30px',
            marginTop: 5,
            marginBottom: 4,
          },
          '& h3': {
            fontSize: 16,
            fontWeight: 'bold',
            lineHeight: '20px',
            marginTop: 5,
            marginBottom: 4,
          },
          '& li, & p, & span': {
            fontSize: 14,
            lineHeight: '24px',
          },
          '& a': {
            color: '#1859FF !important',
            textDecoration: 'underline',
          },
          '& ul': {
            listStyleType: '"・"',
            ul: {
              li: {
                paddingLeft: 5,
              },
            },
          },
          '& ol': {
            listStyleType: 'decimal',
            ol: {
              listStyleType: 'lower-alpha',
              li: {
                paddingLeft: 5,
              },
              ol: {
                listStyleType: 'lower-roman',
                ol: {
                  listStyleType: 'decimal',
                  ol: {
                    listStyleType: 'lower-alpha',
                    ol: {
                      listStyleType: 'lower-roman',
                      ol: {
                        listStyleType: 'decimal',
                        ol: {
                          listStyleType: 'lower-alpha',
                          ol: {
                            listStyleType: 'lower-roman',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        }}
        dangerouslySetInnerHTML={{ __html: body }}
      />
    </Box>
  )
}
